import type { LegalDocument } from '../types';

/** Источник: «Политика защиты детей.docx». Файл сгенерирован — правки вносите в документ. */
export const doc: LegalDocument = {
  title:
    'Политика защиты детей и предотвращения сексуальной эксплуатации и насилия над детьми',
  blocks: [
    {
      kind: 'heading',
      number: '1.',
      text: 'Общие положения',
    },
    {
      kind: 'para',
      number: '1.1.',
      text: 'Настоящая Политика защиты детей и предотвращения сексуальной эксплуатации и насилия над детьми (далее — «Политика») является неотъемлемой частью Политики конфиденциальности и Пользовательского соглашения мобильного приложения Aura (далее — «Приложение») и определяет меры, направленные на предотвращение, выявление и удаление контента, связанного с сексуальным насилием над детьми, а также на защиту несовершеннолетних пользователей Приложения.',
    },
    {
      kind: 'para',
      number: '1.2.',
      text: 'Настоящая Политика разработана в соответствии с законодательством Республики Абхазия, включая нормы о защите прав и законных интересов детей, защите персональных данных, информационной безопасности, а также нормы уголовного законодательства, предусматривающие ответственность за преступления против половой неприкосновенности несовершеннолетних и распространение запрещенных материалов, в том числе:',
    },
    {
      kind: 'bullet',
      text: 'Законом Республики Абхазия от 30.12.2010 N 2812-с-IV "О государственной молодежной политике в Республике Абхазия".',
    },
    {
      kind: 'bullet',
      text: '"Семейным кодексом Республики Абхазия" от 21.07.2009 N 2428-с-IV;',
    },
    {
      kind: 'bullet',
      text: 'Законом Республики Абхазия от 31.12.2008 N 2278-с-IV "О порядке рассмотрения обращений граждан Республики Абхазия";',
    },
    {
      kind: 'bullet',
      text: 'Уголовным кодексм Республики Абхазия" от 10.01.2007 N 1555-с-XIV;',
    },
    {
      kind: 'bullet',
      text: 'Стандартами безопасности детей Google Play (Google Play Child Safety Standards);',
    },
    {
      kind: 'bullet',
      text: 'международными стандартами, включая Конвенцию о правах ребенка (КПР) и протоколы защиты детей INHOPE / Интерпола.',
    },
    {
      kind: 'para',
      number: '1.3.',
      text: 'Целью настоящей Политики является создание прозрачной системы защиты несовершеннолетних пользователей и предотвращение:',
    },
    {
      kind: 'bullet',
      text: 'распространения материалов, связанных с сексуальным насилием и эксплуатацией детей (CSAE/CSAM);',
    },
    {
      kind: 'bullet',
      text: 'вовлечения несовершеннолетних в противоправные сексуальные действия;',
    },
    {
      kind: 'bullet',
      text: 'угроз психическому, физическому и нравственному развитию детей при использовании Приложения.',
    },
    {
      kind: 'para',
      number: '1.4.',
      text: 'Политика является обязательной для всех пользователей Приложения, сотрудников, модераторов и партнеров, участвующих в его администрировании, обслуживании и развитии.',
    },
    {
      kind: 'para',
      number: '1.5.',
      text: 'Настоящая Политика применяется совместно с Политикой конфиденциальности и Пользовательским соглашением и устанавливает специальные меры, направленные на защиту несовершеннолетних.',
    },
    {
      kind: 'heading',
      number: '2.',
      text: 'Термины и возрастные ограничения',
    },
    {
      kind: 'para',
      number: '2.1.',
      text: 'Для целей настоящей Политики используются следующие термины:',
    },
    {
      kind: 'para',
      text: 'Ребенок (Несовершеннолетний) — любое лицо, не достигшее возраста 18 лет, если иное не предусмотрено законодательством страны проживания пользователя.',
    },
    {
      kind: 'para',
      text: 'Несовершеннолетний пользователь — зарегистрированный пользователь Приложения, подтвердивший, что он не достиг возраста 18 лет, или не прошедший процедуру верификации возраста.',
    },
    {
      kind: 'para',
      text: 'Сексуальное насилие и эксплуатация детей (CSAE) — любые действия или контент, направленные на сексуальную эксплуатацию, принуждение, вовлечение, торговлю детьми или демонстрацию сексуальных действий с их участием, включая создание, распространение, хранение, передачу или попытку получения такого контента.',
    },
    {
      kind: 'para',
      text: 'Материалы сексуального насилия над детьми (CSAM) — фото-, видео-, аудио- или иные визуальные материалы, изображающие или имитирующие сексуальные действия с участием лиц, не достигших возраста 18 лет, включая анимированные, виртуальные и компьютерные изображения.',
    },
    {
      kind: 'para',
      text: 'Модерация — совокупность технических и организационных мер по проверке пользовательского контента, включая автоматический анализ (AI-модерацию) и ручную проверку сотрудниками Компании.',
    },
    {
      kind: 'para',
      text: 'Система AI-модерации — алгоритмы машинного обучения и фильтрации, используемые Компанией для обнаружения и предотвращения публикации запрещенного контента, включая CSAM, насилие и эксплуатацию детей.',
    },
    {
      kind: 'para',
      text: 'Верификация возраста — процесс подтверждения возраста пользователя посредством предоставления документов, верификации по селфи или иными способами, обеспечивающими достоверность сведений.',
    },
    {
      kind: 'para',
      number: '2.2.',
      text: 'Возрастные ограничения на использование Приложения:',
    },
    {
      kind: 'para',
      text: 'а)Регистрация в Приложении допускается для лиц, достигших возраста 16 лет.',
    },
    {
      kind: 'para',
      text: 'б)Доступ к разделу «Знакомства», функциям, связанным с публикацией личных фотографий, общению в чатах, участию в мероприятиях и использованию виртуальной валюты Kelvin, предоставляется только пользователям, достигшим возраста 18 лет.',
    },
    {
      kind: 'para',
      text: 'в)Несовершеннолетним разрешается использование Приложения только в разделах, не содержащих функций общения и контента, способного нанести вред их развитию.',
    },
    {
      kind: 'para',
      number: '2.3.',
      text: 'Компания оставляет за собой право:',
    },
    {
      kind: 'bullet',
      text: 'запрашивать дополнительное подтверждение возраста пользователя при обнаружении признаков недостоверности данных;',
    },
    {
      kind: 'bullet',
      text: 'ограничивать или приостанавливать доступ к определенным функциям до завершения проверки;',
    },
    {
      kind: 'bullet',
      text: 'удалять контент, опубликованный с нарушением возрастных ограничений или с участием несовершеннолетних без их письменного согласия и согласия их законных представителей.',
    },
    {
      kind: 'para',
      number: '2.4.',
      text: 'Пользователь несет личную ответственность за достоверность предоставленной информации о возрасте и обязуется не создавать ложные учетные записи от имени несовершеннолетних.',
    },
    {
      kind: 'heading',
      number: '3.',
      text: 'Запрещенный контент и действия (CSAE / CSAM)',
    },
    {
      kind: 'para',
      number: '3.1.',
      text: 'В Приложении строго запрещены размещение, распространение, хранение, создание, передача или любое иное использование контента, который прямо или косвенно связан с сексуальным насилием над детьми, эксплуатацией или вовлечением несовершеннолетних в сексуальные действия.',
    },
    {
      kind: 'para',
      number: '3.2.',
      text: 'К таким материалам относятся, в частности:',
    },
    {
      kind: 'bullet',
      text: 'фото-, видео-, аудиоматериалы или текстовые описания, изображающие сексуальные действия с участием детей или лиц, напоминающих детей;',
    },
    {
      kind: 'bullet',
      text: 'контент, изображающий или описывающий обнаженных или частично одетых несовершеннолетних, даже при отсутствии явных сексуальных действий, если позы, фокус или контекст имеют сексуальный подтекст;',
    },
    {
      kind: 'bullet',
      text: 'анимированные, виртуальные, рисованные или сгенерированные изображения (включая технологию дипфейк), которые создают или имитируют сексуальные сцены с участием несовершеннолетних;',
    },
    {
      kind: 'bullet',
      text: 'контент, поощряющий, оправдывающий или романтизирующий сексуальные отношения между взрослыми и детьми;',
    },
    {
      kind: 'bullet',
      text: 'любые формы вовлечения, шантажа, сексуального вымогательства (сексторшн), угроз, торговли детьми или предложений сексуальных услуг с участием несовершеннолетних;',
    },
    {
      kind: 'bullet',
      text: 'ссылки на внешние ресурсы, чаты, веб-сайты, каналы, группы или аккаунты, содержащие вышеуказанные материалы или их фрагменты.',
    },
    {
      kind: 'para',
      number: '3.3.',
      text: 'Также запрещены следующие действия и формы поведения:',
    },
    {
      kind: 'para',
      text: 'а)Использование Приложения для поиска, общения или установления контакта с несовершеннолетними в сексуальных целях.',
    },
    {
      kind: 'para',
      text: 'б)Отправка несовершеннолетним сообщений, изображений или предложений сексуального характера.',
    },
    {
      kind: 'para',
      text: 'в)Публикация или запрос персональных данных детей (включая фотографии, адреса, сведения о школе, контактные данные родителей) без прямого письменного согласия их законных представителей.',
    },
    {
      kind: 'para',
      text: 'г)Выдача себя за несовершеннолетнего (создание профиля от имени ребенка) с целью обмана, фишинга или сексуальной эксплуатации.',
    },
    {
      kind: 'para',
      text: 'д)Распространение, хранение или пересылка любого контента, нарушающего положения настоящей Политики, даже в личных сообщениях.',
    },
    {
      kind: 'para',
      number: '3.4.',
      text: 'Любая попытка обойти систему модерации или изменить контент с целью сокрытия признаков сексуальной эксплуатации несовершеннолетних считается грубым нарушением настоящей Политики.',
    },
    {
      kind: 'para',
      number: '3.5.',
      text: 'При обнаружении признаков CSAE/CSAM Компания:',
    },
    {
      kind: 'para',
      text: 'незамедлительно блокирует соответствующий контент и/или учетную запись пользователя;',
    },
    {
      kind: 'bullet',
      text: 'сохраняет и документирует данные для целей расследования;',
    },
    {
      kind: 'bullet',
      text: 'уведомляет компетентные органы Республики Абхазия и/ или страны проживания пользователя в порядке, установленном законодательством;',
    },
    {
      kind: 'bullet',
      text: 'при необходимости взаимодействует с правоохранительными органами и международными организациями (включая Интерпол и INHOPE).',
    },
    {
      kind: 'para',
      number: '3.6.',
      text: 'Пользователи, случайно столкнувшиеся с таким контентом, обязаны незамедлительно сообщить о нем с помощью встроенной формы жалобы или по электронной почте safety@aura-vibe.site. Обращение обрабатывается в приоритетном порядке без раскрытия личности заявителя.',
    },
    {
      kind: 'heading',
      number: '4.',
      text: 'Меры модерации, реагирования и отчетности',
    },
    {
      kind: 'para',
      number: '4.1.',
      text: 'Компания использует комплекс технических, организационных и правовых мер для защиты детей и предотвращения распространения контента, связанного с сексуальной эксплуатацией и насилием. Модерация осуществляется на постоянной основе как автоматизированными средствами, так и специально обученной командой специалистов.',
    },
    {
      kind: 'para',
      number: '4.2.',
      text: 'Автоматическая модерация (система AI-модерации)',
    },
    {
      kind: 'para',
      text: 'а)Приложение использует алгоритмы машинного обучения и компьютерного зрения, способные обнаруживать визуальные и текстовые признаки контента сексуального характера, насилия и эксплуатации несовершеннолетних.',
    },
    {
      kind: 'para',
      text: 'б)Алгоритмы обновляются и дообучаются на основе сообщений о нарушениях и отметок модерации.',
    },
    {
      kind: 'para',
      text: 'в)При обнаружении подозрительного контента система:',
    },
    {
      kind: 'para',
      text: '• автоматически блокирует публикацию или ограничивает доступ к ней;',
    },
    {
      kind: 'bullet',
      text: 'направляет материал на ручную проверку;',
    },
    {
      kind: 'bullet',
      text: 'уведомляет группу безопасности для оперативного анализа.',
    },
    {
      kind: 'para',
      text: 'г)Техническая инфраструктура модерации размещается на защищенных серверах, обеспечивающих аудит и логирование всех операций.',
    },
    {
      kind: 'para',
      number: '4.3.',
      text: 'Ручная модерация и реагирование',
    },
    {
      kind: 'para',
      text: 'а)Ручная модерация осуществляется сотрудниками Компании, прошедшими обучение в соответствии со стандартами Google Play CSAE Detection, INHOPE и требованиями законодательства Республики Абхазия.',
    },
    {
      kind: 'para',
      text: 'б)Модераторы действуют в строгом соответствии с внутренними регламентами и обязаны:',
    },
    {
      kind: 'bullet',
      text: 'соблюдать конфиденциальность информации;',
    },
    {
      kind: 'bullet',
      text: 'не копировать, не распространять и не хранить копии материалов, содержащих признаки CSAE;',
    },
    {
      kind: 'bullet',
      text: 'незамедлительно передавать такие материалы Группе реагирования по безопасности.',
    },
    {
      kind: 'para',
      text: 'в)При подтверждении нарушения модератор:',
    },
    {
      kind: 'bullet',
      text: 'удаляет контент и блокирует пользователя;',
    },
    {
      kind: 'bullet',
      text: 'фиксирует событие в журнале нарушений;',
    },
    {
      kind: 'bullet',
      text: 'инициирует процедуру уведомления соответствующих органов.',
    },
    {
      kind: 'para',
      number: '4.4.',
      text: 'Система уведомлений и отчетности',
    },
    {
      kind: 'para',
      text: 'а)При обнаружении контента CSAE/CSAM Компания обязуется:',
    },
    {
      kind: 'bullet',
      text: 'сообщить о нарушении в правоохранительные органы Республики Абхазия (включая подразделения по борьбе с киберпреступностью) и, при необходимости, в компетентные органы страны проживания пользователя;',
    },
    {
      kind: 'bullet',
      text: 'передать хранящиеся данные и технические журналы по официальному запросу органов;',
    },
    {
      kind: 'bullet',
      text: 'сотрудничать с Интерполом, INHOPE и иными уполномоченными организациями, занимающимися борьбой с эксплуатацией детей.',
    },
    {
      kind: 'para',
      text: 'б)В случаях, когда контент не достигает уровня уголовного правонарушения, но содержит потенциально вредоносные элементы (например, провокационные изображения несовершеннолетних, эротизированные позы и т.п.), Компания:',
    },
    {
      kind: 'bullet',
      text: 'уведомляет пользователя о нарушении;',
    },
    {
      kind: 'bullet',
      text: 'направляет предупреждение и рекомендации по исправлению контента;',
    },
    {
      kind: 'bullet',
      text: 'в случае повторных нарушений блокирует учетную запись без возврата стоимости оплаченных функций.',
    },
    {
      kind: 'para',
      number: '4.5.',
      text: 'Внутренний аудит и обучение персонала',
    },
    {
      kind: 'para',
      text: 'а)Компания ежегодно проводит внутренний аудит процедур защиты детей, включая проверку AI-систем, ручной модерации и журналов нарушений.',
    },
    {
      kind: 'para',
      text: 'б)Все сотрудники, имеющие доступ к пользовательскому контенту, проходят обязательное обучение по этическим стандартам, защите детей и процедурам отчетности.',
    },
    {
      kind: 'para',
      text: 'в)Результаты аудита и обучения фиксируются в отчетах, доступных по запросу регулирующих органов или партнеров.',
    },
    {
      kind: 'para',
      number: '4.6.',
      text: 'Компания придерживается политики абсолютной нетерпимости к любым формам сексуальной эксплуатации и насилия над детьми. Любой сотрудник, подрядчик или партнер, нарушивший требования настоящей Политики, подлежит немедленному увольнению и, при необходимости, передаче материалов в компетентные органы.',
    },
    {
      kind: 'heading',
      number: '5.',
      text: 'Заключительные положения',
    },
    {
      kind: 'para',
      text: '5.1. Настоящая Политика является неотъемлемой частью Политики конфиденциальности и Пользовательского соглашения мобильного приложения Aura, разработанного и администрируемого ООО «Фалкон», зарегистрированным в соответствии с законодательством Республики Абхазия (ОГРН 108РА000782, ИНН 11008213, юридический адрес: проспект Мира 16, г. Сухум, Республика Абхазия).',
    },
    {
      kind: 'para',
      number: '5.1.',
      text: 'Политика вступает в силу с момента ее опубликования в Приложении или на официальном веб-сайте https://aura-vibe.site/child_protection, если иное не предусмотрено самой Политикой. Все обновления и изменения публикуются в открытом доступе, и Пользователь обязан самостоятельно ознакомляться с актуальной версией.',
    },
    {
      kind: 'para',
      number: '5.2.',
      text: 'В случае противоречия между положениями настоящей Политики и иными документами Компании применяется более строгая мера защиты несовершеннолетних пользователей.',
    },
    {
      kind: 'para',
      number: '5.3.',
      text: 'Пользователи, сотрудники, подрядчики и иные лица, взаимодействующие с Приложением, обязаны соблюдать требования настоящей Политики и незамедлительно уведомлять Компанию о любых нарушениях, подозрительной деятельности или признаках эксплуатации детей.',
    },
    {
      kind: 'para',
      number: '5.4.',
      text: 'Все сообщения, касающиеся защиты детей, модерации контента, сообщений о нарушениях или запросов о помощи, следует направлять по следующим каналам:',
    },
    {
      kind: 'bullet',
      text: 'электронная почта: safety@aura-vibe.site',
    },
    {
      kind: 'bullet',
      text: 'встроенная форма «Сообщить о нарушении» в Приложении',
    },
    {
      kind: 'bullet',
      text: 'почтовый адрес: ООО «Фалкон», проспект Мира 16, г. Сухум, Республика Абхазия',
    },
    {
      kind: 'para',
      number: '5.5.',
      text: 'Компания рассматривает обращения, связанные с защитой детей, в приоритетном порядке, не позднее 24 (двадцати четырех) часов с момента получения, и при необходимости передает материалы в компетентные органы.',
    },
    {
      kind: 'para',
      number: '5.6.',
      text: 'Настоящая Политика хранится в действующей редакции и в архиве Компании не менее пяти лет с даты замены новой версией. Предыдущие версии предоставляются по официальному запросу компетентных органов.',
    },
    {
      kind: 'para',
      number: '5.7.',
      text: 'Политика применяется с учетом законодательства Республики Абхазия. Если пользователь находится за пределами Республики Абхазия, Компания также может учитывать обязательные требования законодательства страны пребывания пользователя в той части, в которой они применимы к деятельности Компании и не противоречат законодательству Республики Абхазия.',
    },
  ],
};
